'use client';
import React, { useEffect, useState } from 'react';

import {
  Coffee,
  Drinks,
  Fruits,
  Meat,
  Milk,
  Vegetable,
  Snack,
} from './icon/Icon';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa6';
import 'swiper/css';
import 'swiper/css/navigation';
import Link from 'next/link';

const FeaturedCategories = () => {
  const [isMounted, setIsMounted] = useState(false);
  // const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    setIsMounted(true);

    // Ensure navigation buttons exist
    const nextButton = document.querySelector(
      '.featured-categories__slider-next'
    );
    const prevButton = document.querySelector(
      '.featured-categories__slider-prev'
    );

    if (nextButton && prevButton) {
      nextButton.classList.add('custom-swiper-button-next');
      prevButton.classList.add('custom-swiper-button-prev');

      // Initial active button state
      prevButton.classList.remove('active');
      nextButton.classList.add('active');
    }
  }, []);

  const CardData = [
    { id: 0, icon: <Vegetable />, name: 'Vegetable' },
    { id: 1, icon: <Coffee />, name: 'Snack' },
    { id: 2, icon: <Snack />, name: 'Coffee' },
    { id: 3, icon: <Milk />, name: 'Milk' },
    { id: 5, icon: <Vegetable />, name: 'Vegetable' },
    { id: 4, icon: <Drinks />, name: 'Drinks' },
    { id: 55, icon: <Meat />, name: 'Meat' },
    { id: 6, icon: <Fruits />, name: 'Fruits' },
  ];

  return (
    <section
      className="featured-categories padding-top padding-bottom"
      data-aos="fade-up"
      data-aos-duration={1000}
    >
      <div className="container">
        <div className="section-header">
          <div className="section-header__content">
            <h2 className="mb-10">Featured categories</h2>
          </div>
          <div className="section-header__action">
            <div className="swiper-nav swiper-nav--style1">
              <button
                aria-label="Previous slide"
                className="swiper-nav__btn featured-categories__slider-prev"
              >
                <FaArrowLeft />
              </button>
              <button
                aria-label="Previous slide"
                className="swiper-nav__btn featured-categories__slider-next active"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
        <div className="featured-categories__slider">
          {isMounted && (
            <Swiper
              modules={[Navigation]}
              spaceBetween={5}
              slidesPerView={2} // Adjusted for better visibility
              speed={500} // Smooth transition speed
              loop={true}
              breakpoints={{
                576: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 4,
                },
                992: {
                  slidesPerView: 5,
                  spaceBetween: 15,
                },
                1200: {
                  slidesPerView: 7,
                  spaceBetween: 25,
                },
              }}
              navigation={{
                nextEl: '.featured-categories__slider-next',
                prevEl: '.featured-categories__slider-prev',
              }}
              onSlideChange={(swiper) => {
                const nextButton = document.querySelector(
                  '.featured-categories__slider-next'
                );
                const prevButton = document.querySelector(
                  '.featured-categories__slider-prev'
                );

                if (nextButton && prevButton) {
                  if (swiper.isEnd) {
                    nextButton.classList.remove('active');
                  } else {
                    nextButton.classList.add('active');
                  }

                  if (swiper.isBeginning) {
                    prevButton.classList.remove('active');
                  } else {
                    prevButton.classList.add('active');
                  }
                }
              }}
            >
              {CardData.map((data, i) => (
                <SwiperSlide key={i}>
                  <div className="featured-categories__item active">
                    <div
                      className={`featured-categories__item-inner ${!data.id && 'active'}`}
                    >
                      <div className="featured-categories__thumb">
                        {data.icon}
                      </div>
                      <div className="featured-categories__content">
                        <h4>
                          <Link href="/shop" className="stretched-link">
                            {data.name}
                          </Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;
